// @ts-strict-ignore
import { AdSlotEvent, communicationService, TemplateStateHandler } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';

@Injectable({ autobind: false })
export class FloorAdhesionSlotDecisionOnViewabilityHandler implements TemplateStateHandler {
	private readonly displayFloorAdhesionClass = 'floor-adhesion-container--showing';

	async onEnter(): Promise<void> {
		// Mark that the ad is showing
		document.body.classList.add(this.displayFloorAdhesionClass);

		// There are cases where a random collapse would happen hiding the floor adhesion ad.
		// This is to make sure that when the ad does collapse, the wikia bar is reverted to its original position
		communicationService.onSlotEvent(
			AdSlotEvent.HIDDEN_EVENT,
			() => {
				document.body.classList.remove(this.displayFloorAdhesionClass);
			},
			'floor_adhesion',
		);
	}

	async onLeave(): Promise<void> {
		// Mark that the ad is not showing
		document.body.classList.remove(this.displayFloorAdhesionClass);
	}
}
